import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.news-slider');

$slider.slick({
    infinite: false,
    dots: true,
    arrows: false,
    draggable: false,
    slidesToShow: 2,
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            draggable: true
        }
    }]
});

var $calendarSlider = $('.news-calendar__months');

$calendarSlider.each(function () {
    $(this).slick({
        infinite: false,
        dots: false,
        arrows: true,
        draggable: false, 
        swipe: false,
        slidesToShow: 1,
        prevArrow:  $(this).siblings('.news-calendar__arrows').find('.slick-prev'),
        nextArrow:  $(this).siblings('.news-calendar__arrows').find('.slick-next'),
    });

})

